import { render, staticRenderFns } from "./AnimationSettingModal.vue?vue&type=template&id=70037b0d&scoped=true&"
import script from "./AnimationSettingModal.vue?vue&type=script&lang=js&"
export * from "./AnimationSettingModal.vue?vue&type=script&lang=js&"
import style0 from "./AnimationSettingModal.vue?vue&type=style&index=0&id=70037b0d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70037b0d",
  null
  
)

export default component.exports